import React from "react";
import { components } from "react-select";

const { Option } = components;

export const ChangeRoleOption = (props) => {
  return (
    <Option {...props}>
      <span>{props.label}</span>
      <img src={props.data.image} alt="user-role" width="30px" className="img-fluid mx-3"/>
    </Option>
  );
};

export const ChangeInfOption = (props) => {
  return (
    <Option {...props}>
      <span>{props.label}</span>
    </Option>
  );
};
